import { useState } from "react";
import { faqs } from "@/mocks/faq";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            align="center"
            eyebrow="常见问答"
            title="关于潘金莲电影的常见疑问"
            desc="整理了几个最常被问到的问题，帮你快速判断从哪里开始看、怎么看。"
          />
        </Reveal>

        <div className="mt-10 space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <Reveal key={item.q} delay={idx * 40}>
                <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <span className="flex items-start gap-3">
                      <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-primary-500/10 font-heading text-sm font-bold text-primary-600">
                        Q
                      </span>
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 mt-0.5 text-lg text-foreground-500 transition-transform ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen ? (
                    <div className="px-5 pb-5 pl-14">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}